import "Styles/templates/page.partnerships.scss";

import AutoplayVideo from '../components/autoplay-video';

AutoplayVideo();
